import { BatterSingleSessionReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const BatterSingleSessionGameStatsChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, BatterSingleSessionReportChartConfigDto>
) => {
  return <TableChartSidebar chartId='BatterSingleSessionGameStatsChart' configKey='batterSingleSessionGameStatsChartConfig' {...props} />;
};

export default BatterSingleSessionGameStatsChartSidebar;
